import { request } from '@/utils/request'

// 获取个人信息
export function getPersonalInfo() {
  return request({
    url: '/cent-data-core/personal/get',
    method: 'get'
  })
}

// 修改个人信息
export function updatePersonalInfo(data) {
  return request({
    url: '/cent-data-core/personal/update',
    method: 'post',
    data
  })
}

// 修改手机号
export function modifyPhone(data) {
  return request({
    url: '/cent-data-core/personal/phone-edit-verify',
    method: 'post',
    data
  })
}

// 修改手机号码，获取验证码
export function getVerifyCode(params) {
  return request({
    url: '/cent-data-core/personal/send-msg-code',
    method: 'get',
    params
  })
}

// 验证手机号是否唯一
export function validatePhone(params) {
  return request({
    url: '/cent-data-core/account/exist-check',
    method: 'get',
    params
  })
}

// 修改密码（密码/手机号修改）
export function modifyPwd(data) {
  return request({
    url: '/cent-data-core/personal/pwd-edit',
    method: 'post',
    data
  })
}

// 修改密码（初始化修改）
export function initModifyPwd(data) {
  return request({
    url: '/cent-data-core/account/modify-pwd',
    method: 'post',
    data
  })
}
/**
 * 退出登录
 * @returns 
 */
 export function logout(data) {
  return request({
    url: '/cent-auth/logout',
    method: 'post',
    data
  })
}
/**
 * 密码复杂度处理
 * @returns 
 */
export function queryPwdCount() {
  return request({
    url: "/cent-data-core/account/pwd/model",
    method: 'get',
  })
}

/**
 * 获取安全设置
 * @returns 
 */
export function queryPersonalSafeSetting(data) {
  return request({
    url: '/cent-data-core/account/get-dual-auth',
    method: 'post',
    data
  })
}

/**
 * 设置个人安全设置
 * @param {*} data 
 * @returns 
 */
export function confPersonalSafeSetting(data) {
  return request({
    url: '/cent-data-core/account/set-dual-auth',
    method: 'post',
    data
  })
}

/**
 * 获取项目选择状态
 * @returns 
 */
 export function queryPersonalProjectSelection(params) {
  return request({
    url: '/cent-data-core/account/get-show-project',
    params
  })
}

/**
 * 设置项目选择状态
 * @returns 
 */
 export function confPersonalProjectSelection(params) {
  return request({
    url: '/cent-data-core/account/set-show-project',
    method: 'post',
    params
  })
}